const GoogleAnalyticsId = 'XXXXXXXXXX';
const SentryDsn = 'https://XXXXXXXXXX.ingest.us.sentry.io/XXXXXXXXXX';

export const MonitoringConfig = {
    GoogleAnalyticsId,
    SentryDsn,
};
